import React from "react";
import { useSelector } from "react-redux";
import { inspectionSelector } from "../../redux/inspectionSlice";

export const Picutres = () => {
  const { photos } = useSelector(inspectionSelector) || [];
  return (
    <>
      <ul className="previewImage">
        {photos?.map((photo) => (
          <li>
            <div className="imageWrapper">
              <img src={photo} alt="" />
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};
